import guid from "../utils/guid";
import { financialInfoConstants } from "../_constants";
import { history } from "../_helpers";
import { UserBasisApi, SessionService, FinancialService } from "../_services";

export const financialInfoActions = {
    loadFinancialInfo,
    saveFinancialInfo,
    editFinancialInfo,
    addEmployer,
    updateEmployer,
    removeEmployer,
    addIncome,
    updateIncome,
    removeIncome,
    loadFinancialsFromSession,
    onFinancialInfoOpen,
    onFinancialInfoClose,
};

function loadFinancialInfo(){
    return dispatch => {
        return UserBasisApi.getFinancialBasis()
            .then(response => dispatch(loadFinancialInfoSuccess(response.data)))
            .catch(error => failure(error))
    };
    function loadFinancialInfoSuccess(financialInfo){
        return {type: financialInfoConstants.LOAD_FINANCIAL_INFO_SUCCESS, financialInfo: financialInfo  }
    }
    function failure(errorString) {
        return { type: financialInfoConstants.GENERIC_FAILURE, errorString };
    }
}

function saveFinancialInfo(financialInfo){
    return dispatch => {
        return UserBasisApi.saveFinancialBasis(financialInfo)
            .then(() => dispatch(saveFinancialInfoSuccess()))
            .catch(err => {
                // handle error
            })
    }
    function saveFinancialInfoSuccess(){
            return {type: financialInfoConstants.SAVE_FINANCIAL_INFO_SUCCESS, financialInfo}
    }
}
function editFinancialInfo(editedFinancialInfo) {

    return dispatch => {
        return dispatch({ type: financialInfoConstants.EDIT_FINANCIAL_INFO_UPDATE, financialInfo: editedFinancialInfo })
    }
}
 
function loadFinancialsFromSession() {
  return (dispatch) => {
    const userSession = SessionService.getSession();
    return dispatch(success(userSession.employers, userSession.incomes));
  };
  function success(employers, incomes) {
    return {
      type: financialInfoConstants.LOAD_FINANCIALS_FROM_SESSION_SUCCESS,
      employers,
      incomes,
    };
  }
}
 


function addEmployer(employer) {
  return (dispatch) => {
    employer.id = guid();
    employer.isAdd = true;
    SessionService.addEmployer(employer)     
    return dispatch(success(employer));
  };
  function success(employer) {
    return { type: financialInfoConstants.ADD_EMPLOYER_SUCCESS, employer };
  }
}

function updateEmployer(employer) {
  return (dispatch) => {
    if(employer.primaryIncome !== FinancialService.PRIMARY_INCOME_SOURCE_NOTEMPLOYED){
      SessionService.updateEmployer(employer)     
      return dispatch(success(employer));
    }else{
      dispatch(removeEmployer(employer.id));
      dispatch(addIncome(employer));
    }
  };
  function success(employer) {
    return { type: financialInfoConstants.UPDATE_EMPLOYER_SUCCESS, employer };
  }
}

function removeEmployer(id) {
  return (dispatch) => {
    SessionService.removeEmployer(id)     
    return dispatch(success(id));
  };
  function success(id) {
    return { type: financialInfoConstants.REMOVE_EMPLOYER_SUCCESS, id };
  }
}

function addIncome(income) {
  return (dispatch) => {
    income.id = guid();
    income.isAdd = true;
    SessionService.addIncome(income)     
    return dispatch(success(income));
  };
  function success(income) {
    return { type: financialInfoConstants.ADD_INCOME_SUCCESS, income };
  }
}

function updateIncome(income) {
  return (dispatch) => {
    if (
      income.primaryIncome ===
      FinancialService.PRIMARY_INCOME_SOURCE_NOTEMPLOYED
    ) {
      SessionService.updateIncome(income);
      return dispatch(success(income));
    } else {
      dispatch(removeIncome(income.id))
      dispatch(addEmployer(income));
    }
  };
  function success(income) {
    return { type: financialInfoConstants.UPDATE_INCOME_SUCCESS, income };
  }
}

function removeIncome(id) {
  return (dispatch) => {
    SessionService.removeIncome(id)     
    return dispatch(success(id));
  };
  function success(id) {
    return { type: financialInfoConstants.REMOVE_INCOME_SUCCESS, id };
  }
}


function onFinancialInfoOpen() {
  return (dispatch) => {
    return dispatch(success());
  };
  function success() {
    return { type: financialInfoConstants.FINANCIAL_INFO_FORM_OPEN };
  }
}
function onFinancialInfoClose() {
  return (dispatch) => {
    return dispatch(success());
  };
  function success() {
    return { type: financialInfoConstants.FINANCIAL_INFO_FORM_CLOSE };
  }
}




// WEBPACK FOOTER //
// ./src/_actions/financial.actions.js